<div class="dialog-wrapper bg-default-950 p-2 text-inverse-color rounded-xl mx-2">
  <div class="close-button text-end">
    <button (click)="closeDialog()" class="mobile-button">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>
  <div class="mx-4 md:mx-8 md:mt-6">
    <div class="text-2xl font-bold mb-4">
      Welcome to the Extended Archive!
    </div>
    <div class="mb-4">
      The KEXP Extended Archive lets you listen to endless mixes of past KEXP shows <span class="font-semibold">beyond</span>
      the 2 week Streaming Archive.
    </div>
    <div class="mb-6">
      Select a mix by choosing a show or DJ: listen to <span class="font-semibold">DJ Riz</span> on repeat,
      daze out to <span class="font-semibold">Astral Plane</span>,
      or experience <span class="font-semibold">The Roadhouse</span> when <span class="font-semibold">Kevin Sur</span> is hosting.
      There's a lot of music to discover!
    </div>
    <div class="text-center">
      <button (click)="closeDialog()"
              class="rounded-full bg-primary-200 text-default-950 font-semibold px-4 py-2 mb-6">
        Explore mixes
      </button>
    </div>
  </div>
</div>
